const SERVICE_VIDEOS_URL = '/webservice/get-service-videos/';
const SERVICE_FAQS_URL = '/webservice/get-service-faqs/';
const SERVICE_PRICELIST_URL = '/webservice/get-services-price-list/';
const SERVICE_IMAGES_URL = '/webservice/get-service-images/';
const COMPANY_PHONE_NUMBERS_URL = '/webservice/get-company-phone-numbers/';

module.exports = {
  /**
   * Get Booking Visits Via Booking ID
   * @param service_id
   */
  getServiceVideos: function getServiceVideos(service_id) {
      return window.axios.get(SERVICE_VIDEOS_URL, {
          params:
              {
                  service_id: service_id,
              }
      });
  },

  getServiceFaqs: function getServiceFaqs(service_id, company_name, company_id) {
    return window.axios.get(SERVICE_FAQS_URL, { params:
          {
            service_id: service_id,
              company_name: company_name,
              company_id: company_id
          }
    });
  },

  getServicePriceList: function getServicePriceList(service_id, company_name, company_id) {
    return window.axios.get(SERVICE_PRICELIST_URL, { params:
          {
            service_id: service_id,
              company_name: company_name,
              company_id: company_id
          }
    });
  },

    getServiceImages: function getServiceImages(service_id, company_name, company_id) {
        return window.axios.get(SERVICE_IMAGES_URL, { params:
                {
                    service_id: service_id,
                    company_name: company_name,
                    company_id: company_id
                }
        });
    },
  getCompanyPhoneNumbers: function getCompanyPhoneNumbers(company_id) {
    return window.axios.get(COMPANY_PHONE_NUMBERS_URL, { params:
          {
              company_id: company_id
          }
    });
  }
};
